import React, { PureComponent } from 'react';

import FAQ from './FAQ';
import Embed from './Embed';

class Infobox extends PureComponent {
  renderContent = () => {
    switch(this.props.infoboxContent) {
      case 'faq':
        return <FAQ setInfoboxContent={this.props.setInfoboxContent} />
      case 'embed':
        return <Embed setInfoboxContent={this.props.setInfoboxContent} />
      default:
        return null;
    }
  }


  render() {
    return this.renderContent();
  }
}

export default Infobox;
